import { IExpression } from "@@expressions";
import { IComponent } from "./IComponent";

export type InputSliderModel = IComponent & {
    Label?: string;
    Value?: IExpression;
    DefaultValue?: IExpression;
    Min?: number;
    Max?: number;
    Step?: number;
    ShowMarks?: boolean;
    ValueLabel?: InputSliderValueLabel;
    DebunceMs?: number;
};

export enum InputSliderValueLabel {
    Auto = "Auto",
    On = "On",
    Off = "Off",
}
